// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { displayCurrency } from '@seedplanner/shared-utils';
import * as React from 'react';
import { useUserContext } from '../../context/UserContext';
import { Card } from '../../lib/base';
import Table, { type ColumnType } from '../common/table/Table';
import ProductOptions from './ProductOptions';
import { sortContainerSizes } from './sortContainerSizes';

interface Props {
  readonly sizes: {
    readonly id: number;
    readonly size: number;
    readonly unit: string;
    readonly price_per_item?: string | null;
  }[];
  readonly loading: boolean;
  readonly onSuccess: (shouldRefetch: boolean) => void;
}

export default function SizesView({ onSuccess, sizes, loading }: Props) {
  const { currencyCode } = useUserContext();
  if (loading || sizes.length === 0) {
    return null;
  }
  const sorted = sortContainerSizes(sizes);

  const columns: ColumnType[] = [
    {
      name: 'Product',
      values: sorted.map((size) => `${size.size} ${size.unit}`),
    },
    {
      name: 'Price',
      values: sorted.map((size) =>
        size.price_per_item
          ? displayCurrency({
              amount: Number.parseFloat(size.price_per_item),
              currencyCode,
            })
          : '-',
      ),
    },
    {
      name: 'Actions',
      smallName: '',
      numeric: true,
      flex: '0 0 auto',
      values: sorted.map((size) => (
        <ProductOptions
          onSuccess={(shouldRefetch) => onSuccess(shouldRefetch)}
          key={size.id}
          useMoreIcon
          productId={size.id}
        />
      )),
    },
  ];

  return (
    <Card sx={{ mt: 2 }}>
      <Table columns={columns} />
    </Card>
  );
}
